module.exports = __webpack_public_path__ + "img/about_img.a0c958af.png";